import React from 'react';
import PropTypes from 'prop-types';
import StoryboardAutoplayContainer from 'storyboard/containers/storyboard-autoplay-container';
import StoryboardChapterContainer from 'storyboard/containers/storyboard-chapter-container';
import StoryboardNavContainer from 'storyboard/containers/storyboard-nav-container';
import './index.scss';

export default class StoryboardContent extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    enums: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    openModal: PropTypes.func,
    report: PropTypes.object.isRequired,
  };

  static defaultProps = {
    openModal: () => {},
  };

  getFlexDirection(data, enums) {
    const {theme} = data.configuration;
    const {NavPositionEnum} = enums;
    switch (theme.navPosition) {
      case NavPositionEnum.BOTTOM.id:
        return 'column';
      case NavPositionEnum.LEFT.id:
        return 'row-reverse';
      case NavPositionEnum.RIGHT.id:
        return 'row';
      case NavPositionEnum.TOP.id:
        return 'column-reverse';
      default:
        return 'column';
    }
  }

  render() {
    const flexDirection = this.getFlexDirection(
      this.props.data,
      this.props.enums,
    );
    return (
      <div
        className={'StoryboardContent'}
        style={{
          flexDirection,
        }}>
        <StoryboardAutoplayContainer
          data={this.props.data}
          location={this.props.location}>
          <StoryboardChapterContainer
            data={this.props.data}
            enums={this.props.enums}
            location={this.props.location}
            report={this.props.report}
          />
        </StoryboardAutoplayContainer>
        <StoryboardNavContainer
          data={this.props.data}
          enums={this.props.enums}
          location={this.props.location}
          openModal={this.props.openModal}
        />
      </div>
    );
  }
}
